import React, { memo } from 'react';
import { Skeleton } from 'site-modules/shared/components/skeleton/skeleton';

import './links-skeleton.scss';

export const LinksSkeleton = memo(() => (
  <div className="links-skeleton base-inner-width pb-0_75 pb-md-1 px-1 px-md-0_5 px-lg-0 mx-md-auto">
    <Skeleton className="d-block w-35 height-24 rounded-6 mb-1" />
    <Skeleton className="d-block height-54 rounded-12 max-w-360" />
  </div>
));

LinksSkeleton.displayName = 'LinksSkeleton';
